import * as React from 'react';
import * as _ from 'lodash';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import { TestHistoryInfo, ProgramMemberInfo } from './members.types';
import { initialTestHistoryDetail } from './members.constants';
import TestHistoriesTableComponent from './testHistories.table.component';
import TestHistoriesDetailsComponent from './testHistories.details.component';
import {
  cannotWrite,
  isProgramDisabled,
  NOT_ENOUGH_PERMISSION_IMAGE,
  cannotDelete
} from '../util/permission.util';
import { AuthState } from '../auth/auth.types';
import { AdminState } from '../admin/admin.types';
import { PROGRAM } from '../account/Constants';
import { BusinessState } from '../business/business.types';
import SectionPanel from '../util/SectionPanelComponent';

const customDialogContentStyle = {
  width: '100%',
  maxWidth: '1200px',
};

type Props = {
  readonly testHistories: TestHistoryInfo[]
  readonly programMembers: ProgramMemberInfo[]
  readonly authState: AuthState
  readonly adminState: AdminState
  readonly businessState: BusinessState
};

type States = {
  readonly testHistories: TestHistoryInfo[]
  readonly detailDisplayTestHistory: TestHistoryInfo
  readonly showTestHistoriesDeteilsModal: boolean
  readonly testHistoriesDetailsMode: string
};

class TestHistoriesComponent extends React.Component<Props, States> {
  constructor(props: Props) {
    super(props);

    this.state = {
      testHistories: this.props.testHistories,
      detailDisplayTestHistory: JSON.parse(JSON.stringify(initialTestHistoryDetail)),
      showTestHistoriesDeteilsModal: false,
      testHistoriesDetailsMode: 'CREATE'
    };

    this.toggleTestHistoriesDetailsModal = this.toggleTestHistoriesDetailsModal.bind(this);
    this.testHistoryClickHandler = this.testHistoryClickHandler.bind(this);
    this.onRemoveTestHistory = this.onRemoveTestHistory.bind(this);
    this.onSubmitTestHistory = this.onSubmitTestHistory.bind(this);
    this.validateTestHistorySubmit = this.validateTestHistorySubmit.bind(this);
  }

  componentWillReceiveProps(nextProps: Props) {
    this.setState({
      testHistories: nextProps.testHistories
    });
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-12">
            {this.renderTestHistoriesTable()}
          </div>
          <Dialog
            title="Details"
            actions={[this.renderCloseButton()]}
            open={this.state.showTestHistoriesDeteilsModal}
            modal={true}
            contentStyle={customDialogContentStyle}
            autoScrollBodyContent={true}
          >
            <div className="row">
              <div className="col-12">  
                <div className="row pt-4">    
                  <div className="col-12">
                    <h3 className="float-left">Detail</h3>
                  </div>
                  <div className="col-12">
                    <TestHistoriesDetailsComponent
                      testHistory={this.state.detailDisplayTestHistory}
                      programMembers={this.props.programMembers}
                      displayMode={this.state.testHistoriesDetailsMode}
                    />
                    {
                      this.state.testHistoriesDetailsMode === 'CREATE' ?
                        <RaisedButton
                          label="Submit"
                          primary={true}
                          className="float-right"
                          onClick={this.onSubmitTestHistory}
                        /> :
                        <RaisedButton
                          label="Remove"
                          secondary={true}
                          className="float-right mr-2"
                          onClick={this.onRemoveTestHistory}
                          disabled={cannotDelete(PROGRAM, this.props.authState, this.props.adminState)}
                        />
                    }
                  </div>
                </div>
              </div>
            </div>
          </Dialog>
        </div>
      </div>
    );
  }

  private renderTestHistoriesTable = (): JSX.Element => {
    if (isProgramDisabled(this.props.authState, this.props.adminState)) {
      return(<img src={NOT_ENOUGH_PERMISSION_IMAGE} className="img-responsive img-thumbnail"/>);
    } else {
      return(
        <TestHistoriesTableComponent
          testHistories={this.state.testHistories}
          // testHistoryClickHandler={this.testHistoryClickHandler}
        />
      );
    }
  }

  private renderCloseButton = (): JSX.Element => {
    return(
      <RaisedButton 
        label="Close"
        primary={true}
        keyboardFocused={true}
        className="mr-2"
        onClick={() => this.toggleTestHistoriesDetailsModal()}
      />
    );
  }

  private toggleTestHistoriesDetailsModal() {
    if (this.state.testHistoriesDetailsMode === 'CREATE') {
      let displayTestHistory: TestHistoryInfo = _.cloneDeep(initialTestHistoryDetail);
      if (this.props.programMembers.length > 0) {
        displayTestHistory.programId = this.props.programMembers[0].program.id;
        displayTestHistory.programName = this.props.programMembers[0].program.name;
        displayTestHistory.levelId = this.props.programMembers[0].level.id;
        displayTestHistory.level = this.props.programMembers[0].level.level;
      }

      this.setState({
        detailDisplayTestHistory: displayTestHistory
      });
    }
    
    this.setState({
      showTestHistoriesDeteilsModal: !this.state.showTestHistoriesDeteilsModal,
      testHistoriesDetailsMode: (this.state.showTestHistoriesDeteilsModal)
        ? 'CREATE'
        : this.state.testHistoriesDetailsMode
    });
  }

  private testHistoryClickHandler(clickedTestHistory: TestHistoryInfo) {
    if (cannotWrite(PROGRAM, this.props.authState, this.props.adminState)) {
      return;
    } else {
      this.setState(
        {
          detailDisplayTestHistory: _.cloneDeep(clickedTestHistory),
          testHistoriesDetailsMode: 'EDIT'
        },
        this.toggleTestHistoriesDetailsModal
      );
    }
  }

  private onRemoveTestHistory() {
    let newTestHistories = this.state.testHistories;
    for (let i = 0; i < newTestHistories.length; i++) {
      if (newTestHistories[i].id === this.state.detailDisplayTestHistory.id) {
        newTestHistories.splice(i, 1);
      }
    }

    this.setState(
      {
        testHistories: newTestHistories
      },
      this.toggleTestHistoriesDetailsModal
    );
  }

  private onSubmitTestHistory() {
    if (!this.validateTestHistorySubmit()) {
      return;
    }
    let newTestHistories = this.state.testHistories;
    newTestHistories.push(_.cloneDeep(this.state.detailDisplayTestHistory));

    this.setState(
      {
        testHistories: newTestHistories
      },
      this.toggleTestHistoriesDetailsModal
    );
  }

  private validateTestHistorySubmit() {
    const testHistory = this.state.detailDisplayTestHistory;
    return testHistory.programId && testHistory.programId !== 0
      && testHistory.levelId && testHistory.levelId !== 0;
  }
}

export default TestHistoriesComponent;



// WEBPACK FOOTER //
// ./src/members/testHistories.component.tsx